import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { addChatAlert } from 'store/slices/AlertSlice'
import useAuthenticatedSocket from 'hooks/useAuthenticatedSocket'
import MessageNotification from 'utils/MessageNotification'

const HandleWsChat = ({ user_id, chatId }) => {
  const dispatch = useDispatch()
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'info' })
  useAuthenticatedSocket(chatId ? `/ws/chat/${chatId}/` : null, {
    enabled: Boolean(chatId && user_id),
    onMessage: message => {
      if (!message.id || !message.content || message.user === user_id) return
      dispatch(addChatAlert(message))
      setNotify({ isOpen: true, sender: message.sender, message: message.content, type: 'info', image: message.image, link: `chats/${chatId}/` })
    },
  })
  return <MessageNotification notify={notify} setNotify={setNotify} />
}
export default HandleWsChat
